"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const snapshot_1 = require("./snapshot");
function snapshot(options, style, localisation = {
    SAVE: 'SAVE',
    SHARE: 'SHARE',
    NowOpenFilesAppToShare: 'Now open files app to share',
    TapAndHoldToSave: 'Tap and hold the image<br/>to save to your Photos app',
}) {
    const manager = new snapshot_1.default(style);
    manager.captureimage(options, localisation);
}
exports.default = snapshot;
//# sourceMappingURL=index.js.map